module.exports = {"pathContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/brand-design-fenton.json
// module id = 407
// module chunks = 161205263619399